import {intRandom} from './_randNum';
const imagesLoaded = require('imagesloaded');

export function homeGallery() {
  const homeGallery = document.querySelector('.js-home-gallery');
  const homeGalleryOver = document.querySelector('.js-home-gallery-2');
  const ww = window.document.documentElement.clientWidth;

  if(homeGalleryOver && currentCoverObj) {
    let el = '';
    const coverInit = () => {
      const ratio = currentCoverObj.height/currentCoverObj.width*100;

      // img
      const img = document.createElement('img');
      img.classList.add('is-square');
      img.setAttribute('src', currentCoverObj.image);
      const rotate = intRandom(-90,90);
      img.style.transform = `rotate(${rotate}deg)`;
      const rotatingDuration = intRandom(10000,50000);
      const isRotateDirection = intRandom(1,2);
      if (isRotateDirection == 2) {
        img.style.animation = `rotating ${rotatingDuration}ms linear infinite`;
      } else {
        img.style.animation = `rotating2 ${rotatingDuration}ms linear infinite`;
      }

      // image container
      const a = document.createElement('a');
      a.classList.add('image-container', 'image-child', 'js-trigger-drawer');
      a.setAttribute('href', currentCoverObj.permalink);
      a.setAttribute('data-handle', 'hiroshima');
      a.style.paddingBottom = `${ratio}%`;
      if(currentCoverObj.href) {
        a.setAttribute('href', currentCoverObj.href);
      } else {
        a.setAttribute('href', 'javascript:void(0)');
      }

      // post
      el = document.createElement('div');
      el.classList.add('post');
      el.style.width = `${intRandom(minSize,maxSize)}%`;

      const pos = `${intRandom(0,2)}`;
      const posTop = `${intRandom(20,80)}`;
      const posLeft = `${intRandom(20,80)}`;
      const speed = intRandom(10000,20000);
    
      imagesLoaded(img, () => {
        if(pos == 2) {
          el.classList.add('is-v');
          el.style.left = `${posLeft}%`;
          el.style.animation = `gallery-v ${speed}ms linear 0ms 1`;
          a.style.animation = `galleryChild-v ${speed}ms linear 0ms 1`;
        } else {
          el.classList.add('is-h');
          el.style.top = `${posTop}%`;
          el.style.animation = `gallery-h ${speed}ms linear 0ms 1`;
          a.style.animation = `galleryChild-h ${speed}ms linear 0ms 1`;
        }
        
        a.appendChild(img);
        el.appendChild(a);
        homeGalleryOver.appendChild(el);

        setTimeout(() => {
          el.classList.add('loaded');
        },0);

        setTimeout(() => {
          el.remove();
          coverInit();
        },speed);
      });
    }

    coverInit();
  }

  if(homeGalleryOver && iconObj) {
    for(let i = 0; i < iconObj.length; i++) {
      const currentObj = iconObj[i];
      let el = '';
      const iconInit = () => {
        // icon
        const icon = document.createElement('div');
        icon.innerHTML = `${currentObj.icon}`;
        const rotate = intRandom(-90,90);
        icon.style.transform = `rotate(${rotate}deg)`;
        const rotatingDuration = intRandom(10000,50000);
        const isRotateDirection = intRandom(1,2);
        if (isRotateDirection == 2) {
          icon.style.animation = `rotating ${rotatingDuration}ms linear infinite`;
        } else {
          icon.style.animation = `rotating2 ${rotatingDuration}ms linear infinite`;
        }

        // link
        const a = document.createElement('a');
        a.classList.add('js-home-post-title');
        a.setAttribute('href', currentObj.url);
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');

        // post
        el = document.createElement('div');
        el.classList.add('post', 'is-icon');

        if (ww >= 768) {
          el.style.width = `${intRandom(minSize*0.4,maxSize*0.5)}%`;
        } else {
          el.style.width = `${intRandom(minSize*0.5,maxSize)}%`;
        }

        const pos = `${intRandom(0,2)}`;
        const posTop = `${intRandom(20,80)}`;
        const posLeft = `${intRandom(20,80)}`;
        const speed = intRandom(10000,20000);

        if(pos == 2) {
          el.classList.add('is-v');
          el.style.left = `${posLeft}%`;
          el.style.animation = `gallery-v ${speed}ms linear 0ms 1`;
          a.style.animation = `galleryChild-v ${speed}ms linear 0ms 1`;
        } else {
          el.classList.add('is-h');
          el.style.top = `${posTop}%`;
          el.style.animation = `gallery-h ${speed}ms linear 0ms 1`;
          a.style.animation = `galleryChild-h ${speed}ms linear 0ms 1`;
        }
      
        a.appendChild(icon);
        el.appendChild(a);
        homeGalleryOver.appendChild(el);

        setTimeout(() => {
          el.remove();
          iconInit();
        },speed);
      }

      iconInit();
    }
  }
  
  if(homeGallery && imagesObj) {
    const obj = imagesObj.images01;
    const randoms = [];
    const randomsNum = obj.length-1;
    let current = randomsNum;

    const homeGalleryChange = (isNext = true) => {
      if(isNext) {
        if(current == randomsNum) {
          current = 0;
        } else {
          current++;
        }
      } else {
        if(current == 0) {
          current = randomsNum;
        } else {
          current--;
        }
      }
      const currentNum = randoms[current];
      const currentObj = obj[currentNum];
      const ratio = currentObj.height/currentObj.width*100;

      // image container
      const imgContainer = document.createElement('div');
      imgContainer.classList.add('image-container');
      imgContainer.style.paddingBottom = `${ratio}%`;

      // img
      const img = document.createElement('img');
      img.setAttribute('src', currentObj.image);
      const rotate = intRandom(-90,90);
      img.style.transform = `rotate(${rotate}deg)`;
      const rotatingDuration = intRandom(10000,50000);
      const isRotateDirection = intRandom(1,2);
      if (isRotateDirection == 2) {
        img.style.animation = `rotating ${rotatingDuration}ms linear infinite`;
      } else {
        img.style.animation = `rotating2 ${rotatingDuration}ms linear infinite`;
      }
      const isStar = intRandom(0,50);
      if (isStar == 50) {
        img.classList.add('is-star');
      // } else {
      //   const isHexagon = intRandom(0,50);
      //   if (isHexagon == 50) {
      //     img.classList.add('is-hexagon');
      //   } else {
      //     const isParallelogram = intRandom(0,50);
      //     if (isParallelogram == 50) {
      //       img.classList.add('is-parallelogram');
      //     } else {
      //       const isRhombus = intRandom(0,50);
      //       if (isRhombus == 50) {
      //         img.classList.add('is-rhombus');
      //       } else {
      //         const isRightChevron = intRandom(0,50);
      //         if (isRightChevron == 50) {
      //           img.classList.add('is-right-chevron');
      //         } else {
      //           if(currentObj.width >= currentObj.height) img.classList.add('is-horizontal');
      //         }
      //       }
      //     }
      //   }
      }

      // post
      const el = document.createElement('div');
      el.classList.add('post');

      if (ww >= 768) {
        el.style.width = `${intRandom(minSize,maxSize)}%`;
      } else {
        el.style.width = `${intRandom(minSize*3,maxSize*2.5)}%`;
      }

      const pos = `${intRandom(0,2)}`;
      const posTop = `${intRandom(-10,110)}`;
      const posLeft = `${intRandom(-10,110)}`;
      const speed = intRandom(15000,50000);

      imagesLoaded(img, () => {
        if(pos == 2) {
          el.classList.add('is-v');
          el.style.left = `${posLeft}%`;
          el.style.animation = `gallery-v ${speed}ms linear 0ms 1`;
          imgContainer.style.animation = `galleryChild-v ${speed}ms linear 0ms 1`;
        } else {
          el.classList.add('is-h');
          el.style.top = `${posTop}%`;
          el.style.animation = `gallery-h ${speed}ms linear 0ms 1`;
          imgContainer.style.animation = `galleryChild-h ${speed}ms linear 0ms 1`;
        }
        
        imgContainer.appendChild(img);
        el.appendChild(imgContainer);
        homeGallery.appendChild(el);

        setTimeout(() => {
          el.classList.add('loaded');
        },0);

        setTimeout(() => {
          el.remove();
        },speed);
      });
    }

    const homeGalleryInit = () => {
      const min = 0;
      const max = obj.length-1;
      for(let i = min; i <= max; i++) {
        while(true) {
          var tmp = intRandom(min, max);
          if(!randoms.includes(tmp)) {
            randoms.push(tmp);
            break;
          }
        }
      }
      homeGalleryChange();

      if (ww >= 768) {
        let time = intRandom(minTiming,maxTiming);
        setInterval(() => {
          time = intRandom(minTiming,maxTiming);
          homeGalleryChange();
        },time);
      } else {
        let time = intRandom(minTiming*1.5,maxTiming*1.5);
        setInterval(() => {
          time = intRandom(minTiming*1.5,maxTiming*1.5);
          homeGalleryChange();
        },time);
      }
    }
    
    homeGalleryInit();
  }
}